import React from "react";
import { Tick } from "@wuilt/ui-components";
import classnames from "classnames";
import classes from "./DropDown.module.scss";
const DropDown = props => {
  const {
    visible,
    children,
    direction
  } = props;
  const dropDirectionUp = direction === "up";
  if (!visible) return null;
  const contentContainerClassName = classnames({
    [classes.contentContainer]: true,
    [classes.shown]: visible,
    [classes.up]: dropDirectionUp,
    [classes.down]: !dropDirectionUp
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: contentContainerClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.innerContentContainer
  }, children)));
};
DropDown.Item = ({
  selected,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames({
    [classes.option]: true,
    [classes["--selected"]]: selected
  })
}, selected ? /*#__PURE__*/React.createElement("div", {
  className: classes.optionSelectedIndicator
}, /*#__PURE__*/React.createElement(Tick, {
  size: "10px"
})) : /*#__PURE__*/React.createElement("div", {
  className: classes.optionNotSelectedIndicator
}), children);
export default DropDown;
//# sourceMappingURL=DropDown.js.map